module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-17.c1780ebd.jpg";